import script from "./CurrentLiabilityTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentLiabilityTrade.vue?vue&type=script&setup=true&lang=js"

import "./CurrentLiabilityTrade.vue?vue&type=style&index=0&id=7bf11e16&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf11e16"]])

export default __exports__